import classNames from "classnames";
import styles from "./styles.module.scss";
import { getStatus } from "./utils";

export const AspectAlert = ({ data }) => {
  const status = getStatus(data);

  return (
    <div className={classNames(styles.alertBlock, styles[status])}>
      <span className={styles.content}>
        Your product lost $1,646.57 due to bad aspect
      </span>
    </div>
  );
};
